<template>
  <div class="messageCenter">
    <div class="tabs">
      <ul class="role-auth-title">
        <li :class="{ active: isRead == 0 }" @click="chooseType(0)">系统资源</li>
        <li :class="{ active: isRead == 1 }" @click="chooseType(1)">项目资源</li>
        <li :class="{ active: isRead == 2 }" @click="chooseType(2)">应用资源</li>
      </ul>
    </div>
    <div class="body">
      <div class="top">
        <el-form inline class="form" size="small">
          <el-form-item>
            <el-button size="small" type="primary" @click="viewModule(0)"> 新增 </el-button>
            <el-button size="small" type="danger" plain :disabled="batchDelList.length === 0" @click="batchDelOPen">批量删除 </el-button>
            <el-button v-show="isRead === 2" size="small" plain @click="jumpAppManage">跳转应用管理 </el-button>
            <span v-show="isRead === 2">(如果您要更改应用下的权限资源，请尽量通过应用管理来更改！)</span>
          </el-form-item>
          <el-form-item style="float: right">
            <el-input v-model="searchName" clearable size="small" placeholder="请输入资源名称、请求地址、权限标识" style="width: 270px">
              <i slot="suffix" class="el-icon-search el-input__icon" />
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="table">
        <el-table
          key="isRead"
          ref="messageData"
          v-loading="loading"
          element-loading-text="拼命加载中"
          row-key="permissionId"
          highlight-current-row
          :indent="20"
          :tree-props="{ children: 'childList', hasChildren: 'hasChildren_' }"
          :data="allModule"
          height="100%"
          border
          :row-class-name="addclass"
          :expand-row-keys="expandRow"
          class="treeTab"
          @current-change="handleCurrentChange"
        >
          <template slot="empty">
            <img :src="zanwu" alt="" />
            <p style="font-size: 16px; color: #000; margin-top: 36px">暂无数据</p>
          </template>
          <el-table-column class-name="table-module-name" label="资源名称" min-width="260px">
            <template #default="{ row }">
              <el-checkbox v-model="row.isChecked" :true-label="1" :false-label="0" @change="setTreeLimit(row)">
                <span class="row-icon">
                  <img v-if="row.resourceType == 0" :src="P_MENU" alt="" />
                  <img v-else-if="row.resourceType == 1" :src="P_BUTTON" alt="" />
                  <img v-else :src="P_PAGE" alt="" />
                </span>
                <el-link type="primary" :class="[row.isUse == 0 ? '' : 'noIsUse']" @click="openUpdateModule(row)">
                  <span :ref="row.permissionId" class="tabLinkSpan" :title="row.permissionName">{{ row.permissionName }}</span>
                </el-link>
              </el-checkbox>
            </template>
          </el-table-column>
          <el-table-column label="排序" type="type" prop="sortNum" align="center" min-width="80px" />
          <el-table-column label="类型" align="center" min-width="100px">
            <template #default="{ row }">
              <span v-if="row.resourceType == 0">菜单</span>
              <span v-else-if="row.resourceType == 1">按钮</span>
              <span v-else>页面</span>
            </template>
          </el-table-column>
          <el-table-column label="请求地址" prop="location" min-width="300px" align="center" />
          <el-table-column label="权限标志" prop="permissionKey" min-width="200px" align="center" />
          <el-table-column label="资源状态" prop="isUse" min-width="100px" align="center">
            <!-- :filtered-value="filterText" -->
            <template #default="{ row }">
              <span v-if="row.isUse == 0">启用</span>
              <span v-else style="color: red">禁用</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="300px" align="center">
            <template #default="{ row }">
              <el-button v-if="!isDynamicRouterBtn(row)" type="text" size="small" @click="openUpdateModule(row)"> 修改 </el-button>
              <el-button v-if="row.isUse == 1" type="text" size="small" @click="isUserModule(row)"> 启用 </el-button>
              <el-button v-if="row.isUse == 0" type="text" size="small" @click="isUserModule(row)"> 禁用 </el-button>
              <el-button type="text" size="small" @click="deleteModuleHandler(row)"> 删除 </el-button>
              <el-button v-if="!isDynamicRouterBtn(row)" type="text" size="small" @click="viewModule(0, { pid: row.permissionId })"> 添加 </el-button>
              <el-button v-if="row.dynamicRouter && row.useTemplate !== 1" type="text" size="small" @click="editForm(row.formCode)"> 打开表单 </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <permissionDlg
      ref="editModule"
      :moduleForm="moduleForm"
      :allModuleProp="allModuleProp"
      :moduleSelectTree="moduleSelectTree"
      :groupList="groupList"
      :treeMetaData="treeMetaData"
      :currentRow="currentRow"
      @closeEditModule="closeEditModule"
      @submitEditModuleHandler="submitEditModuleHandler"
    ></permissionDlg>
    <permissionDelDlg ref="delDlg" @submitDelPermission="submitDelPermission"> </permissionDelDlg>
  </div>
</template>

<script>
import resources from "@/CommonDP/service/admin/resources-service";
import applicationSettingsService from "@/CommonDP/service/applicationSettings-service";
import treeUtils from "@/CommonDP/utils/treeUtils";

import basePermissionVue from "@/CommonDP/adminPages/settings/resources/basevue.js";
export default {
  name: "AdminResources",
  extends: basePermissionVue,
  data() {
    return {
      tableData: [],
      appTableData: [],
      isRead: 0,
      searchName: "",
      expandRow: [],
      batchDelList: []
    };
  },
  computed: {
    operatorTableData() {
      const { tableData, appTableData, isRead } = this;
      return isRead === 2 ? appTableData : tableData;
    },
    // 下拉父级
    moduleSelectTree() {
      const tableData = this.isRead === 2 ? this.appTableData : this.tableData;
      const list = tableData.map((item) => {
        if (item.childList.length === 0) {
          item.isLeaf = true;
          return {
            permissionName: item.permissionName,
            permissionId: item.permissionId,
            isLeaf: true
          };
        } else {
          return item;
        }
      });
      return [
        {
          permissionName: "根目录",
          permissionId: "0",
          isLeaf: true
        },
        ...list
      ];
    },
    allModule() {
      const tableData = this.isRead === 2 ? this.appTableData : this.tableData;
      if (this.searchName) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.currentRow = null;
        const handleTreeData = this.handleTreeData(tableData, this.searchName);
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.expandRow = [];
        this.setExpandRow(handleTreeData);
        return handleTreeData;
      }
      // 只有在上一次是搜索状态本次是非搜索状态才进行处理
      if (this.findingLocation && this.currentRow) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.findingLocation = false;
        // 如果筛选状态下点击某行高亮，则滚动屏幕到高亮行
        this.$nextTick(() => {
          const expandRow = treeUtils.findPathInTree(tableData, "permissionId", "childList", this.currentRow.permissionId);
          console.log("expandRow", expandRow);
          const viewY = this.$refs[expandRow.at(-1).permissionId].getBoundingClientRect().y;
          const elBody = this.$refs.messageData.$el.querySelector(".el-table__body-wrapper");
          const elBodyY = elBody.getBoundingClientRect().y;
          const elBodyH = elBody.getBoundingClientRect().height;
          console.log(viewY, elBodyY, elBodyH);
          elBody.scrollTop = viewY - elBodyY - elBodyH / 4;
          this.$refs.messageData.setCurrentRow(expandRow.at(-1));
        });
      }
      return tableData;
    },

    flatModuleList() {
      const { allModule } = this;
      const list = [];
      const each = (childList) => {
        for (const module of childList) {
          list.push(module);
          const { childList } = module;
          if (childList && childList.length > 0) each(childList);
        }
      };
      each(allModule);
      return list;
    }
  },

  methods: {
    chooseType(key) {
      this.messageData = [];
      this.isRead = key;
      this.refreshCurTableData();
    },
    refreshCurTableData() {
      if (this.isRead === 2) {
        this.getModuleAppList();
      } else {
        this.getModuleList();
      }
    },
    // 所有的树
    async getModuleList() {
      const id = this.isRead;
      this.loading = true;
      const { data } = await resources.queryPermissionTree(id);
      this.loading = false;
      this.batchDelList = [];
      this.tableData = this.disposeData(data);
    },

    async getModuleAppList() {
      this.loading = true;
      const { data } = await applicationSettingsService.queryAllAppPermissionTree();
      this.loading = false;
      this.appTableData = this.disposeData(data);
      this.expandRow = [];
      this.$nextTick(() => {
        this.setExpandRow(this.appTableData);
      });
    },

    // 修改模块和子元素可见性
    setTreeLimit(row) {
      if (this.operatorTableData === this.allModule) {
        const { batchDelList } = this;
        const { isChecked, permissionId } = row;
        if (isChecked) {
          batchDelList.push(row);
        } else {
          const index = batchDelList.findIndex((item) => item.permissionId === permissionId);
          batchDelList.splice(index, 1);
        }
      } else {
        const { batchDelList } = this;
        const { isChecked, permissionId } = row;
        // 筛选状态下，找到tabledata中的数据
        const tableItem = treeUtils.findInTree(this.operatorTableData, "permissionId", "childList", permissionId);
        tableItem.isChecked = isChecked;
        if (isChecked) {
          batchDelList.push(tableItem);
        } else {
          const index = batchDelList.findIndex((item) => item.permissionId === permissionId);
          batchDelList.splice(index, 1);
        }
      }
    },

    jumpAppManage() {
      this.$router.push({ path: "/applicationSettings" });
    }
  }
};
</script>
<style lang="scss">
.form {
  .el-form-item {
    margin-bottom: 0;
  }
}
</style>
<style lang="scss" scoped>
.messageCenter {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-width: 700px;

  /deep/.el-form-item {
    margin-bottom: 10px;
  }

  .tabs {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: #fff;
    border-bottom: 1px solid #ebefff;

    /deep/.el-badge__content {
      z-index: 1;
    }

    /deep/.el-radio-button__inner {
      padding: 10px 30px;
    }

    .role-auth-title {
      display: flex;
      padding: var(--small-space) var(--big-space);

      li {
        line-height: 36px;
        margin-right: 30px;
        text-align: center;
        cursor: pointer;
        font-size: 16px;
        font-weight: 600;
      }

      .active {
        border-bottom: 2px solid var(--theme-color);
        box-sizing: border-box;
        color: var(--theme-color);
      }
    }
  }

  .body {
    height: calc(100% - 70px);
    background-color: #fff;
    padding-bottom: 10px;
    position: relative;

    .top {
      padding: var(--middle-space) var(--big-space) 0;
    }

    .table {
      position: absolute;
      padding: 0 var(--big-space);
      left: 0;
      right: 0;
      bottom: 10px;
      top: calc(32px + var(--middle-space) * 2);
      .noIsUse {
        color: #ccc;
      }
      .noIsUse:hover:after {
        border-color: #ccc;
      }
      .el-button--text {
        padding: 0 !important;
      }
    }
  }

  .width-220 {
    width: 100%;
  }

  .el-table /deep/ .warm-row {
    color: #ccc;
  }

  .row-icon {
    margin-right: 6px;
    img {
      vertical-align: middle;
      width: 18px;
      height: 18px;
    }
  }
}

::v-deep .dialog-form {
  height: 70vh;
  padding-right: 12px;
  overflow: auto;
  .el-form-item {
    margin-bottom: 12px;
  }
  .el-form-item__error {
    padding-top: 0 !important;
  }
}

::v-deep(.el-table__row:not([class*="el-table__row--level-"])) {
  td:first-child {
    padding-left: 23px;
  }
}

::v-deep {
  .el-table__placeholder {
    margin-left: 3px;
  }

  .cell {
    font-size: 14px;

    span {
      font-size: 14px;
    }
  }
}
.delPermissionBox {
  padding: 5px 16px;
  .titleError {
    font-size: 16px;
    margin-bottom: 10px;
  }
  .title {
    margin-bottom: 10px;
    font-size: 16px;
    margin-left: 5px;
  }
  .checkbox {
    margin-bottom: 5px;
    margin-left: 5px;
    font-size: 16px;
  }
  .password {
    padding-left: 30px;
    span {
      margin-right: 5px;
      font-size: 14px;
    }
  }
}
</style>
